import { Box, Button, Container, Typography, useMediaQuery } from "@mui/material";
import plano_empresarial from "../../../../assets/images/planos/plano-empresarial.jpg";
import { styleImage, styleTitle } from ".";

const Empresarial: React.FC<{ setPlanoAtual(newValue: string): void }> = ({ setPlanoAtual }) => {
    
    const isMobile = useMediaQuery("(max-width:768px)");

    return (
        <Box p={isMobile ? 0 : 2} pb={1} >
            <Container 
                style={{
                    display:"flex" ,
                    alignItems:"center" ,
                    justifyContent:"space-between",
                    flexDirection: isMobile ? "column" :"row"
                }}
            >
            <Box 
                flex={1} 
                width="100%"
                height="300px" 
                bgcolor="#e0e0e0" 
                display="flex" 
                alignItems="center" 
                justifyContent="center"
                borderRadius="8px"
            >
                {/* Substituir por imagem quando disponível */}
                <img style={styleImage} src={plano_empresarial} />
            </Box>
            <Box flex={1} ml={isMobile ? 0 : 4}>
                <Typography variant={isMobile ? "h6" : "h5"} style={styleTitle} fontWeight="bold">
                Plano empresarial Innova: 
                </Typography>
                <Typography variant="body1" color="textSecondary" mt={2} textAlign="justify">
                Saúde que acompanha o crescimento da sua empresa:
                </Typography>
                <Typography variant="body1" color="textSecondary" mt={2} textAlign="justify">
                Ideal para empresas de todos os portes em Rondônia 
                Rede referenciada com cobertura local 
                Opção de coparticipação para controle de custos 
                Modalidades de reembolso.
                </Typography>
                <Box mt={3} display="flex" justifyContent={ isMobile ? "center" : "flex-end" }>

                <Button variant="contained" color="warning" onClick={() => setPlanoAtual("empresarial")}>
                    FALE COM A GENTE
                </Button>
                </Box>
            </Box>
            
            </Container>
        </Box>
    )
}
export default Empresarial;